export default __webpack_public_path__ + "static/media/bookshelflisted.2da2b1a20ae00cd021025c164905835b.webp";